import { oz } from '@weft/utils';

export const SYSTEM_EVENT_MESSAGE_TYPES = Object.freeze({
  Overage: 'Overage',
  AnonymousCustomerIngested: 'AnonymousCustomerIngested',
  UpcomingRenewal: 'UpcomingRenewal',
  InvoiceApproved: 'InvoiceApproved',
});

export const SystemEventMessageTypeSchema = oz.nativeEnum(SYSTEM_EVENT_MESSAGE_TYPES);

export type SystemEventMessageType = oz.TypeOf<typeof SystemEventMessageTypeSchema>;